// src/components/usuario/ArticulosUsuario.jsx
import React, { useEffect, useState, useMemo } from "react";
import api from "../../../../api";
import { API_BASE } from "../../../../api";
import { ENDPOINTS } from "../../Utils/Endpoints";
import { getSessionUserId } from "../../../../utils/SessionUser";

// Helper para construir la URL completa de la imagen
const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith("http") || path.startsWith("data:")) return path;
    const baseUrl = API_BASE.replace(/\/api\/?$/, "");
    return `${baseUrl}${path}`;
};

// Placeholder image
const PLACEHOLDER_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='250' viewBox='0 0 400 250'%3E%3Crect fill='%23E5E7EB' width='400' height='250'/%3E%3Cpath fill='%239CA3AF' d='M163 142.5l24-24 24 24 48-48 48 48V187H163v-44.5zm48-39.5c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z'/%3E%3C/svg%3E";

const ArticulosUsuario = ({ onVolver, initialItem }) => {
    const [articulos, setArticulos] = useState([]);
    const [loading, setLoading] = useState(true);

    // Estado para modal
    const [showModal, setShowModal] = useState(!!initialItem);
    const [articuloSeleccionado, setArticuloSeleccionado] = useState(initialItem || null);
    const [areasNegocio, setAreasNegocio] = useState([]);
    const [categorias, setCategorias] = useState([]);

    // Estado para filtros
    const [filtros, setFiltros] = useState({
        texto: '',
        area: 'Todas',
        categoria: 'Todas'
    });

    useEffect(() => {
        const cargarDatos = async () => {
            try {
                setLoading(true);
                const idUsr = getSessionUserId();
                if (!idUsr) {
                    setLoading(false);
                    return;
                }

                const [resArticulos, resCategorias, resAreas] = await Promise.all([
                    api.get(ENDPOINTS.articulosDashboardByUsuarioId(idUsr)).catch(e => { console.error("Error fetching articles", e); return { data: [] }; }),
                    api.get(ENDPOINTS.categorias).catch(e => { console.error("Error fetching categories", e); return { data: [] }; }),
                    api.get(ENDPOINTS.areasNegocios).catch(e => { console.error("Error fetching areas", e); return { data: [] }; })
                ]);

                const catsArr = resCategorias.data || [];
                const areasArr = resAreas.data || [];

                setAreasNegocio(areasArr);
                setCategorias(catsArr);

                // Crear mapas para nombres cuando no vienen en el objeto principal
                const areasMap = {};
                areasArr.forEach(a => {
                    const id = a.idAreaNegocio ?? a.IdAreaNegocio;
                    const nm = a.nombre ?? a.Nombre ?? a.descripcion ?? a.Descripcion;
                    if (id) areasMap[id] = nm;
                });

                const catsMap = {};
                catsArr.forEach(c => {
                    const id = c.idCategoria ?? c.IdCategoria;
                    const nm = c.nombre ?? c.Nombre;
                    if (id) catsMap[id] = nm;
                });

                const data = (resArticulos.data || []).map(a => {
                    const idCat = a.idCategoria ?? a.IdCategoria;
                    const idArea = a.idAreaNegocio ?? a.IdAreaNegocio;

                    return {
                        id: a.idArticulo ?? a.IdArticulo,
                        titulo: a.titulo ?? a.Titulo ?? "Sin título",
                        resumen: a.resumen ?? a.Resumen ?? "",
                        contenido: a.contenido ?? a.Contenido ?? "",
                        fechaPublicacion: a.fechaPublicacion ?? a.FechaPublicacion,
                        imagen: a.imagenUrl ?? a.ImagenUrl,
                        categoria: a.nombreCategoria ?? a.NombreCategoria ?? catsMap[idCat] ?? "General",
                        area: a.nombreArea ?? a.NombreArea ?? areasMap[idArea] ?? "Corporativo",
                        autor: a.nombreAutor ?? a.NombreAutor ?? a.autor ?? a.Autor ?? "Experto Corporativo",
                        destacado: a.destacada || a.destacado || a.Destacada || a.Destacado || false,
                        tags: []
                    };
                });

                const ordenados = data.sort((a, b) => {
                    const fA = new Date(a.fechaPublicacion || 0).getTime();
                    const fB = new Date(b.fechaPublicacion || 0).getTime();
                    return fB - fA;
                });
                setArticulos(ordenados);
            } catch (e) {
                console.error("Error cargando articulos:", e);
            } finally {
                setLoading(false);
            }
        };

        cargarDatos();
    }, []);

    const handleFiltrosChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const articulosFiltrados = useMemo(() => {
        return articulos.filter(articulo => {
            const matchTexto = !filtros.texto ||
                articulo.titulo.toLowerCase().includes(filtros.texto.toLowerCase()) ||
                articulo.resumen.toLowerCase().includes(filtros.texto.toLowerCase()) ||
                articulo.contenido.toLowerCase().includes(filtros.texto.toLowerCase());

            const matchArea = filtros.area === 'Todas' || articulo.area === filtros.area;
            const matchCategoria = filtros.categoria === 'Todas' || articulo.categoria === filtros.categoria;

            return matchTexto && matchArea && matchCategoria;
        });
    }, [articulos, filtros]);

    const handleVerDetalle = (articulo) => {
        setArticuloSeleccionado(articulo);
        setShowModal(true);
    };

    return (
        <div className="intra-news-page">
            {/* HEADER */}
            <header className="intra-news-header">
                <div>
                    {onVolver && (
                        <button
                            type="button"
                            className="intra-button-back"
                            onClick={onVolver}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '0.5rem 1rem',
                                marginBottom: '1rem',
                                backgroundColor: 'transparent',
                                border: '1px solid #cbd5e1',
                                borderRadius: '8px',
                                color: '#475569',
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f1f5f9';
                                e.currentTarget.style.transform = 'translateX(-4px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'translateX(0)';
                            }}
                        >
                            <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>←</span>
                            <span>Volver al dashboard</span>
                        </button>
                    )}
                    <h1 className="intra-news-title">Artículos publicados</h1>
                </div>
            </header>

            {/* FILTROS */}
            <section className="intra-news-toolbar">
                <div className="intra-news-filters" style={{ width: '100%', display: 'flex', gap: '1rem', alignItems: 'flex-end', marginBottom: '1.5rem' }}>
                    <div className="intra-filter-group" style={{ flex: '1', minWidth: '200px' }}>
                        <label className="intra-label" htmlFor="filtroTexto">
                            Buscar
                        </label>
                        <input
                            id="filtroTexto"
                            name="texto"
                            type="text"
                            className="intra-input"
                            value={filtros.texto}
                            onChange={handleFiltrosChange}
                            placeholder="Buscar por título, resumen o contenido..."
                        />
                    </div>

                    <div className="intra-filter-group" style={{ width: '180px' }}>
                        <label className="intra-label" htmlFor="filtroArea">
                            Área
                        </label>
                        <select
                            id="filtroArea"
                            name="area"
                            className="intra-select"
                            value={filtros.area}
                            onChange={handleFiltrosChange}
                        >
                            <option value="Todas">Todas</option>
                            {areasNegocio.map((area, idx) => (
                                <option key={area.idAreaNegocio || area.IdAreaNegocio || idx} value={area.nombre || area.Nombre || area.descripcion || area.Descripcion}>
                                    {area.nombre || area.Nombre || area.descripcion || area.Descripcion}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="intra-filter-group" style={{ width: '180px' }}>
                        <label className="intra-label" htmlFor="filtroCategoria">
                            Categoría
                        </label>
                        <select
                            id="filtroCategoria"
                            name="categoria"
                            className="intra-select"
                            value={filtros.categoria}
                            onChange={handleFiltrosChange}
                        >
                            <option value="Todas">Todas</option>
                            {categorias.map((cat, idx) => (
                                <option key={cat.idCategoria || cat.IdCategoria || idx} value={cat.nombre || cat.Nombre}>
                                    {cat.nombre || cat.Nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </section>

            {/* CONTENIDO */}
            {loading ? (
                <p style={{ textAlign: 'center', color: '#94a3b8', padding: '3rem' }}>
                    Cargando artículos...
                </p>
            ) : articulos.length === 0 ? (
                <div style={{
                    textAlign: 'center',
                    padding: '4rem 2rem',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                }}>
                    <p style={{ fontSize: '1.125rem', color: '#64748b', marginBottom: '0.5rem' }}>
                        No hay artículos publicados
                    </p>
                    <p style={{ fontSize: '0.875rem', color: '#94a3b8' }}>
                        Cuando se publiquen artículos, aparecerán aquí
                    </p>
                </div>
            ) : articulosFiltrados.length === 0 ? (
                <div style={{
                    textAlign: 'center',
                    padding: '4rem 2rem',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                }}>
                    <p style={{ fontSize: '1.125rem', color: '#64748b', marginBottom: '0.5rem' }}>
                        No se encontraron artículos
                    </p>
                    <p style={{ fontSize: '0.875rem', color: '#94a3b8' }}>
                        Intenta ajustar los filtros de búsqueda
                    </p>
                </div>
            ) : (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '1rem',
                }}>
                    {articulosFiltrados.map((articulo) => (
                        <article
                            key={articulo.id}
                            onClick={() => handleVerDetalle(articulo)}
                            style={{
                                backgroundColor: articulo.destacado ? '#fffbeb' : '#fff',
                                border: `1px solid ${articulo.destacado ? '#fbbf24' : '#3b82f6'}`,
                                borderRadius: '16px',
                                overflow: 'hidden',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                cursor: 'pointer',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.borderColor = articulo.destacado ? '#fbbf24' : '#3b82f6';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.borderColor = articulo.destacado ? '#fbbf24' : '#3b82f6';
                            }}
                        >
                            {/* Ribbon de importancia */}
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '40px',
                                height: '40px',
                                zIndex: 10,
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    width: 0,
                                    height: 0,
                                    borderStyle: 'solid',
                                    borderWidth: '0 40px 40px 0',
                                    borderColor: `transparent ${articulo.destacado ? '#fbbf24' : '#3b82f6'} transparent transparent`,
                                }} />
                                <div style={{
                                    position: 'absolute',
                                    top: articulo.destacado ? '2px' : '3px',
                                    right: '5px',
                                    color: 'white',
                                    fontSize: articulo.destacado ? '1rem' : '0.75rem',
                                    fontWeight: 'bold',
                                    zIndex: 11
                                }} title={articulo.destacado ? "Artículo Destacado" : "Artículo Reciente"}>
                                    {articulo.destacado ? '★' : 'A'}
                                </div>
                            </div>
                            
                            {/* Imagen */}
                            <div style={{
                                width: '100%',
                                height: '160px',
                                overflow: 'hidden',
                                backgroundColor: '#f8fafc',
                                position: 'relative'
                            }}>
                                <img
                                    src={getImageUrl(articulo.imagen) || PLACEHOLDER_IMAGE}
                                    alt={articulo.titulo}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                        if (e.target.src !== PLACEHOLDER_IMAGE) {
                                            e.target.src = PLACEHOLDER_IMAGE;
                                        }
                                    }}
                                />
                                {articulo.destacado && (
                                    <div style={{
                                        position: 'absolute',
                                        bottom: '8px',
                                        left: '8px',
                                        backgroundColor: '#fffbeb',
                                        color: '#b45309',
                                        padding: '2px 8px',
                                        borderRadius: '6px',
                                        fontSize: '0.65rem',
                                        fontWeight: '700',
                                        border: '1px solid #fde68a'
                                    }}>
                                        Destacado
                                    </div>
                                )}
                            </div>

                            {/* Contenido */}
                            <div style={{ padding: '1rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                {/* Area & Category */}
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '0.75rem' }}>
                                    <span style={{
                                        backgroundColor: '#eff6ff',
                                        color: '#1e40af',
                                        padding: '1px 6px',
                                        borderRadius: '4px',
                                        fontSize: '0.6rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        border: '1px solid #bfdbfe'
                                    }}>
                                        {articulo.area || "Corporativo"}
                                    </span>
                                    {articulo.categoria && (
                                        <span style={{
                                            backgroundColor: '#f1f5f9',
                                            color: '#475569',
                                            padding: '1px 6px',
                                            borderRadius: '4px',
                                            fontSize: '0.6rem',
                                            fontWeight: '700',
                                            border: '1px solid #e2e8f0',
                                            textTransform: 'uppercase'
                                        }}>
                                            {articulo.categoria}
                                        </span>
                                    )}
                                </div>

                                {/* Título */}
                                <h3 style={{
                                    fontSize: '0.95rem',
                                    fontWeight: '700',
                                    color: '#1e293b',
                                    margin: '0 0 0.5rem 0',
                                    lineHeight: '1.4',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '2',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    minHeight: '2.8em'
                                }}>
                                    {articulo.titulo}
                                </h3>

                                {/* Resumen */}
                                <p style={{
                                    fontSize: '0.8rem',
                                    color: '#64748b',
                                    marginBottom: '1rem',
                                    lineHeight: '1.5',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '3',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    flex: 1
                                }}>
                                    {articulo.resumen || articulo.contenido?.substring(0, 100)}
                                </p>

                                {/* Footer */}
                                <div style={{
                                    paddingTop: '0.75rem',
                                    marginTop: 'auto',
                                    borderTop: '1px solid #f1f5f9',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '0.7rem',
                                    color: '#94a3b8'
                                }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '500' }}>
                                        👤 {articulo.autor?.split(' ')[0] || "Sistema"}
                                    </span>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        📅 {new Date(articulo.fechaPublicacion || articulo.fecha).toLocaleDateString()}
                                    </span>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}

            {/* MODAL DE DETALLE */}
            {showModal && articuloSeleccionado && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                    onClick={() => setShowModal(false)}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            width: '90%',
                            maxWidth: '900px',
                            maxHeight: '90vh',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 2rem', borderBottom: '1px solid #e2e8f0' }}>
                            <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>
                                Artículo
                            </h2>
                            <button
                                type="button"
                                onClick={() => setShowModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '2rem',
                                    lineHeight: 1,
                                    color: '#64748b',
                                    cursor: 'pointer'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Content - Scrollable */}
                        <div style={{ padding: '2rem', overflowY: 'auto' }}>
                            {/* Imagen */}
                            {articuloSeleccionado.imagen && (
                                <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden' }}>
                                    <img
                                        src={getImageUrl(articuloSeleccionado.imagen) || PLACEHOLDER_IMAGE}
                                        alt={articuloSeleccionado.titulo}
                                        style={{
                                            width: '100%',
                                            maxHeight: '400px',
                                            objectFit: 'cover',
                                        }}
                                        onError={(e) => {
                                            if (e.target.src !== PLACEHOLDER_IMAGE) {
                                                e.target.src = PLACEHOLDER_IMAGE;
                                            }
                                        }}
                                    />
                                </div>
                            )}

                            {/* Meta info */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                                <span
                                    className="intra-badge-category"
                                    style={{
                                        padding: '0.5rem 1rem',
                                        borderRadius: '12px',
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        backgroundColor: '#f1f5f9',
                                        color: '#475569',
                                    }}
                                >
                                    {articuloSeleccionado.categoria}
                                </span>
                                {articuloSeleccionado.fechaPublicacion && (
                                    <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                        <strong>Publicado:</strong> {new Date(articuloSeleccionado.fechaPublicacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </span>
                                )}
                                {articuloSeleccionado.autor && (
                                    <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                        <strong>Por:</strong> {articuloSeleccionado.autor}
                                    </span>
                                )}
                            </div>

                            {/* Título */}
                            <h3 style={{
                                fontSize: '1.75rem',
                                fontWeight: 600,
                                color: '#1e293b',
                                margin: '0 0 1rem 0',
                                lineHeight: 1.3
                            }}>
                                {articuloSeleccionado.titulo}
                            </h3>

                            {/* Resumen */}
                            {articuloSeleccionado.resumen && (
                                <div style={{
                                    fontSize: '1.125rem',
                                    color: '#64748b',
                                    lineHeight: 1.6,
                                    marginBottom: '1.5rem',
                                    fontStyle: 'italic',
                                    paddingLeft: '1rem',
                                    borderLeft: '3px solid #e2e8f0'
                                }}>
                                    {articuloSeleccionado.resumen}
                                </div>
                            )}

                            {/* Contenido completo */}
                            <div style={{
                                fontSize: '1rem',
                                color: '#475569',
                                lineHeight: 1.7,
                                whiteSpace: 'pre-wrap'
                            }}>
                                {articuloSeleccionado.contenido || "Sin contenido disponible"}
                            </div>

                            {/* Tags */}
                            {articuloSeleccionado.tags && articuloSeleccionado.tags.length > 0 && (
                                <div style={{
                                    marginTop: '2rem',
                                    paddingTop: '1.5rem',
                                    borderTop: '1px solid #e2e8f0',
                                    display: 'flex',
                                    gap: '0.5rem',
                                    flexWrap: 'wrap'
                                }}>
                                    {articuloSeleccionado.tags.map((tag, idx) => (
                                        <span
                                            key={idx}
                                            style={{
                                                padding: '0.25rem 0.75rem',
                                                borderRadius: '12px',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                backgroundColor: '#f1f5f9',
                                                color: '#475569',
                                            }}
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ArticulosUsuario;
